import { Alert, Button } from "@svea/design-system-components-react";
import {
	ButtonGroup,
	Dialog,
	Heading,
	Markdown,
	Stack,
	SvgIcon,
	useText,
} from "@sveabank/cc-common";
import Card from "../../components/card";
import { useFetchApplicationDetailsQuery } from "../../services/application";

type Props = {
	isOpen: boolean;
	onClose: () => void;
	onSubmit: () => void;
	applicationId?: string;
};

const NewApplicationModal = ({ isOpen, onClose, onSubmit, applicationId }: Props) => {
	const [t, texts] = useText();

	const { data: applicationDetails } = applicationId
		? useFetchApplicationDetailsQuery(applicationId)
		: { data: undefined };

	const isOrgEf = applicationDetails?.organization.orgType === "ef";

	return (
		<Dialog
			isDismissable={false}
			isOpen={isOpen}
			center={false}
			heading={t(texts.dashboardPage.newApplicationModal.title)}
		>
			<Dialog.Content>
				<Stack gap={8}>
					{isOrgEf && (
						<Alert
							kind="information"
							title={t(texts.dashboardPage.newApplicationModal.creditAlert.title)}
						>
							{t(texts.dashboardPage.newApplicationModal.creditAlert.content)}
						</Alert>
					)}
					<Markdown allowParagraphs>{t(texts.dashboardPage.newApplicationModal.content)}</Markdown>
					<Card fullWidth classNames="bg-background-tertiary" boxShadow={false}>
						<Stack gap={8}>
							<Heading.H3 className="text-text-primary">
								{t(texts.dashboardPage.newApplicationModal.infoBoxTitle)}
							</Heading.H3>
							<Stack component="ul" gap={4}>
								<Stack direction="row" align="start" gap={4} component="li">
									<SvgIcon imageSrc="LIST_CHECK" height={24} className="text-foreground-success" />
									{t(texts.dashboardPage.newApplicationModal.infoItem1)}
								</Stack>
								<Stack direction="row" align="start" gap={4} component="li">
									<SvgIcon imageSrc="LIST_CHECK" height={24} className="text-foreground-success" />
									{t(texts.dashboardPage.newApplicationModal.infoItem2)}
								</Stack>
								<Stack direction="row" align="start" gap={4} component="li">
									<SvgIcon imageSrc="LIST_CHECK" height={24} className="text-foreground-success" />
									{t(texts.dashboardPage.newApplicationModal.infoItem3)}
								</Stack>
							</Stack>
						</Stack>
					</Card>
				</Stack>
			</Dialog.Content>
			<Dialog.Footer>
				<ButtonGroup row>
					<Button variant="primary" onPress={onSubmit}>
						{t(texts.dashboardPage.newApplicationModal.start)}
					</Button>
					<Button variant="secondary" onPress={onClose}>
						{t(texts.common.goBack)}
					</Button>
				</ButtonGroup>
			</Dialog.Footer>
		</Dialog>
	);
};

export default NewApplicationModal;
